module.exports = __webpack_public_path__ + "static/media/Galdisa_SaltedPumpkinSeeds.27c898ad.pdf";